import React, { useEffect, useState } from "react";
import "../Styles/dashboard.css";
import { Link, useNavigate, useLocation} from "react-router-dom";
import { useSelector } from "react-redux";
import { ButtonGroup, Table, Button } from "react-bootstrap";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import { failed, success } from "../../common/Toastify";
import { decryptData, encryptData } from "../../EncryptDecrypt.js";
import { Skeleton, TableCell, Tooltip, InputLabel } from "@mui/material";
import Select from "react-select";
import CustomPagination from "../../common/components/Pagination/CustomPagination.js";
import SearchBar from "../../common/components/SearchBar.js";
import "./Style.css"
import EditIcon from "../../../assets/images/edit.png";
import ViewIcon from "../../../assets/images/view.png";
import DeleteIcon from "../../../assets/images/delete.png"
import moment from "moment";
import { ViewDateTime } from "../../../utils/DateSupport.js";
import { useOrgQuery } from "../../../hooks/ReactQueryHooks/useOrgQuery.js";
import { deleteReportDelivery, getReportDeliveries, getReportDeliveryById } from "../../api/ReportDeliveries/index.js";
import EditReportDelivery from "./EditReportDelivery.js";
import ViewReportDelivery from "./ViewReportDelivery.js";
import { useConfirmDialog } from "../../../hooks/useConfirmDialog";

function ReportDeliveries(props) {
    const [filterData, setFilterData] = useState([]);
    const [reportDeliveryList, setReportDeliveryList] = useState([]);
    const [sortBy, setSortBy] = useState("AscName");
    const [isLoading, setIsLoading] = useState(false);
    const { getConfirmation } = useConfirmDialog();
    const adminOrgs = useSelector((state) => state?.auth?.user?.organizations)
    const permissions = useSelector((state) => state?.auth?.user?.permissions);
    const user = useSelector((state) => state?.auth?.user)
    const [page, setPage] = useState(0);
    const navigate = useNavigate()
    const location = useLocation();
    const rowsPerPage = 10;
    const totalRows = filterData.length;
    const [organizations, setOrganizations] = useState([]);
    const [orgId, setOrgId] = useState(location?.state?.orgId || adminOrgs[0].id);
    const [modalShow, setModalShow] = useState(false);
    const [reportDeliveryId, setReportDeliveryId] = useState("");
    const [reportDeliveryData, setReportDeliveryData] = useState(null);

    useOrgQuery({
        onSuccess: (data) => {

            setOrganizations(data?.map((org) => ({ label: org?.name, value: org?.id }))) 
        },
        refetchOnWindowFocus: false,
    })
    
    const handleOrgChange = (event) => {
            setOrgId(event.value);
    }

    const sortFilterData = (sort_by) => {
        setSortBy(sort_by)
        switch (sort_by) {
            case "AscName":
                setFilterData(reportDeliveryList?.sort((a, b) => (decryptData(a.name) > decryptData(b?.name)) ? 1 : ((decryptData(b?.name) > decryptData(a?.name)) ? -1 : 0)))
                break;
            case "DscName":
                setFilterData(reportDeliveryList?.sort((a, b) => (decryptData(a.name) < decryptData(b?.name)) ? 1 : ((decryptData(b?.name) < decryptData(a?.name)) ? -1 : 0)))
                break;
            case "AscDeliveryType":
                  setFilterData(reportDeliveryList?.sort((a, b) => (decryptData(a?.type) > decryptData(b?.type)) ? 1 : ((decryptData(b?.type) > decryptData(a?.type)) ? -1 : 0)))
                  break;
            case "DscDeliveryType":
                  setFilterData(reportDeliveryList?.sort((a, b) => (decryptData(a?.type) < decryptData(b?.type)) ? 1 : ((decryptData(b?.type) < decryptData(a?.type)) ? -1 : 0)))
                  break;
            case "AscTarget":
                  setFilterData(reportDeliveryList?.sort((a, b) => (decryptData(a?.target) > decryptData(b?.target)) ? 1 : ((decryptData(b?.target) > decryptData(a?.target)) ? -1 : 0)))
                  break;
            case "DscTarget":
                  setFilterData(reportDeliveryList?.sort((a, b) => (decryptData(a?.target) < decryptData(b?.target)) ? 1 : ((decryptData(b?.target) < decryptData(a?.target)) ? -1 : 0)))
                  break;
            case "AscFileType":
                  setFilterData(reportDeliveryList?.sort((a, b) => (decryptData(a?.fileType) > decryptData(b?.fileType)) ? 1 : ((decryptData(b?.fileType) > decryptData(a?.fileType)) ? -1 : 0)))
                  break;
            case "DscFileType":
                  setFilterData(reportDeliveryList?.sort((a, b) => (decryptData(a?.fileType) < decryptData(b?.fileType)) ? 1 : ((decryptData(b?.fileType) < decryptData(a?.fileType)) ? -1 : 0)))
                  break;
            case "AscOrganization":
                  setFilterData(reportDeliveryList?.sort((a, b) => (organizations.find(org => org.value == a.orgId)?.label > organizations.find(org => org.value == b.orgId)?.label) ? 1 : (organizations.find(org => org.value == b.orgId)?.label > organizations.find(org => org.value == a.orgId)?.label) ? -1 : 0))
                  break;
            case "DscOrganization":
                  setFilterData(reportDeliveryList?.sort((a, b) => (organizations.find(org => org.value == a.orgId)?.label < organizations.find(org => org.value == b.orgId)?.label) ? 1 : (organizations.find(org => org.value == b.orgId)?.label < organizations.find(org => org.value == a.orgId)?.label) ? -1 : 0))
                  break;
            default:
                setFilterData(filterData)
                break;
        }
    }

    const handleShowReportDelivery = async(data) => {
        setModalShow(!modalShow)
        setReportDeliveryId(data?.id)
        setReportDeliveryData(data)
    }

    const handleDelete = async (data) => {
       
        const confirmed = await getConfirmation({
            title: "Attention!",
            entryName: data.name,
            actionBtnTitle: "Delete"
        });
        if (confirmed) {
            deleteReportDelivery(data.id, data.orgId).then(res => {
                success(data.name + " deleted successfully");
            })
            .catch(res => failed(res?.response?.data?.message || res?.response?.data?.error || res.message))
            .finally(() => getReportDeliveriesList());
        }
    }

    const sortObjArray = (obj) => {
        let sorted = obj?.sort((a, b) =>  a?.label.toLowerCase() > b?.label.toLowerCase() ? 1 : -1);
        return sorted || []
    }

    const getReportDeliveriesList = async () => {
        setIsLoading(true);
        try {
            let list = await getReportDeliveries(orgId)
            if(list?.status) {
                setReportDeliveryList(list?.data);
                setFilterData(list?.data);
            }
            else {
                setReportDeliveryList([]);
                setFilterData([])
            }
        }
        catch(error) {
            console.error('Error fetching report deliveries list:', error);
            failed(error.message)     
        }
        finally {
            setIsLoading(false);
        }
    }
     useEffect(() => {
        getReportDeliveriesList();
    }, [orgId])
    
    return (
        <>
        <section className="common-listing">
              {modalShow ?
                        <ViewReportDelivery
                            modalShow={modalShow}
                            handleShow={handleShowReportDelivery}
                            handleDelete ={handleDelete}
                            refreshTable={() => { getReportDeliveriesList() }}
                            isReadOnly={(permissions?.includes("Report Deliveries - Edit") || user?.["cognito:groups"].includes("Super-Admin"))}
                            organizations={organizations}
                            data={reportDeliveryData}
                        /> : null}
                 
                    <div className="heading-wrap h-change mb-4">
                        {organizations.length > 1 &&                
                        <div style={{width:300}}>
                        <Select
                            keyField={"organization"}
                            label={"Select Organization"}
                            selectLabel="Select Organization"
                            options={sortObjArray(organizations)}
                            isLoading={organizations?.length > 1 ? false : true}
                            readOnly={organizations?.length > 1 ? false : true}
                            hideRequired={true}
                            onChange={handleOrgChange}
                            className="search-select"
                            classNamePrefix="select"
                            placeholder="Select Organization..."
                        />                        
                        </div>}
                        <div className="right-wrap">
                            <Button
                                variant="primary"
                                active={permissions?.includes("Report Deliveries - Edit")}
                                onClick = {() => navigate('/app/create-report-delivery',  {state: {orgId }})}>Create Report Delivery</Button>
                        </div>
                    </div>

                        
    
                     <div className="table-wrap">
                         <Table responsive>
                             <thead>
                                 <tr>
                                     <th style={{ cursor: "pointer" }} onClick={() => sortFilterData(sortBy === "AscName" ? "DscName" : "AscName")}>
                                     Report Delivery Name
                                     {sortBy === "AscName" ? <span>
                                             <ArrowDropUp />
                                         </span> : <span>
                                             <ArrowDropDown />
                                         </span>}
                                     </th>
                                     <th style={{ cursor: "pointer" }} onClick={() => sortFilterData(sortBy === "AscDeliveryType" ? "DscDeliveryType" : "AscDeliveryType")}>
                                     Delivery Type
                                     {sortBy === "AscDeliveryType" ? <span>
                                             <ArrowDropUp />
                                         </span> : <span>
                                             <ArrowDropDown />
                                         </span>}
                                     </th>
                                     <th style={{ cursor: "pointer" }} onClick={() => sortFilterData(sortBy === "AscTarget" ? "DscTarget" : "AscTarget")}> 
                                         Target
                                         {sortBy === "AscTarget" ? <span>
                                             <ArrowDropUp />
                                         </span> : <span>
                                             <ArrowDropDown />
                                         </span>}
                                     </th>
                                     <th style={{ cursor: "pointer" }} onClick={() => sortFilterData(sortBy === "AscFileType" ? "DscFileType" : "AscFileType")}> 
                                         File Type
                                         {sortBy === "AscFileType" ? <span>
                                             <ArrowDropUp />
                                         </span> : <span>
                                             <ArrowDropDown />
                                         </span>}
                                     </th>
                                     <th style={{ cursor: "pointer" }} onClick={() => sortFilterData(sortBy === "AscOrganization" ? "DscOrganization" : "AscOrganization")}>
                                         Organization
                                         {sortBy === "AscOrganization" ? <span>
                                             <ArrowDropUp />
                                         </span> : <span>
                                             <ArrowDropDown />
                                         </span>}
                                     </th>
                                     <th style={{ textAlign: "center"}}>Action</th>
                                 </tr>
                             </thead>
                            <tbody>
                                {isLoading ? (
                                    [1, 2, 3, 4, 5, 6]?.map((val) => (
                                        <tr key={val}>
                                            <td>
                                                <Skeleton animation="wave" />
                                            </td>
                                            <td>
                                                <Skeleton animation="wave" />
                                            </td>
                                            <td>
                                                <Skeleton animation="wave" />
                                            </td>
                                            <td>
                                                <Skeleton animation="wave" />
                                            </td>
                                            <td>
                                                <Skeleton animation="wave" />
                                            </td>
                                        </tr>
                                    ))
                                ) : filterData?.length > 0 ? (
                                    filterData?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)?.map((data) => {
                                        const {id, name, type, target, fileType, orgId} = data;
                                        return (
                                        <tr key={id}>
                                            <td>{name?.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') || '-'}</td>
                                            <td>{type || '-'}</td>
                                            <td>{target || '-'}</td>
                                            <td>{fileType.toUpperCase() || '-'}</td>
                                            <td>{organizations.find(org => org.value === orgId)?.label?.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') || '-'}</td>
                                            <td>
                                            <div className="action-wrap" style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
                                                <Tooltip title={"View"}>
                                                    <Link
                                                        to=""
                                                        variant="primary"
                                                        className="view-btn"
                                                        onClick={() =>  handleShowReportDelivery(data)}
                                                    >
                                                    <img src={ViewIcon} alt="View PDF" />
                                                    </Link>
                                                </Tooltip>
                                                <Tooltip title="Edit">
                                                <Link
                                                    to=""
                                                    className="success-btn"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        navigate("/app/edit-report-delivery", {state: {id, orgId}});
                                                      }}
                                                >
                                                    <img src={EditIcon} alt="Edit" />
                                                </Link>
                                                </Tooltip>
                                                <Tooltip title="Delete">
                                                <Link
                                                    to=""
                                                    className="success-btn"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        handleDelete(data)
                                                      }}
                                                >
                                                    <img src={DeleteIcon} alt="Delete" />
                                                </Link>
                                                </Tooltip>
                                            </div>
                                            </td>
                                        </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <TableCell colSpan={"7"} style={{ textAlign: "center" }}>
                                            No Data Available
                                        </TableCell>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                    {filterData?.length > 0 ? <CustomPagination tableData={filterData} totalRows={totalRows} rowsPerPage={rowsPerPage} page={page} handlePage={(pageNo) => setPage(pageNo)} /> : null}
                </section>
        </>
    );

}

export default ReportDeliveries;